var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-auth"},[_c('google-signin-btn',{staticClass:"sign-in-button",attrs:{"label":"Sign In"},on:{"click":_vm.googleSignIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }